import { render, staticRenderFns } from "./LamsBaseLegalDocType.vue?vue&type=template&id=acd41d8a&scoped=true&"
import script from "./LamsBaseLegalDocType.vue?vue&type=script&lang=js&"
export * from "./LamsBaseLegalDocType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd41d8a",
  null
  
)

export default component.exports